import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import MDButton from "components/MDButton";
// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";


import { getFoulWords, improveFoulWords } from "../../redux/slices/foulWordsSlice";

import FoulWordsList from "./components/FoulWordsList";
import AddFoulWordsSection from "./components/AddFoulWordsSection";
import ImprovedFoulList from "./components/ImprovedFoulList";


const FoulWords = () => {
    const dispatch = useDispatch()
    const { foulWords: foulWordsData, loading, showingImproved,
        fetchError,
        deleteError,
        updateError,
        improveError,
    } = useSelector((state) => state.foulWordsDetails);
 
    const handleApiCall = async () => {
        try {
           dispatch(getFoulWords({ page: 1, limit: 20 }));
        } catch (e) {
            console.log("e: ", e);
        }
    };
    useEffect(() => {
        handleApiCall();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        {fetchError ?
                            (<MDBox
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                width="100vw"
                                height="100vh"
                                position="fixed"
                                top={0}
                                left={0}
                            >
                                <MDTypography>
                                    Error Occured
                                </MDTypography>
                            </MDBox>)
                            : (<MDBox>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="light"
                                    borderRadius="lg"
                                    coloredShadow="light"
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", sm: "row" },
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 2,
                                        p: 3,
                                    }}
                                >
                                    {/* Left: Heading */}
                                    <MDBox>
                                        <MDTypography variant="h5" color="white">
                                            Foul Words
                                        </MDTypography>
                                    </MDBox>

                                    {/* Right: Buttons container */}
                                    <MDBox
                                        sx={{
                                            display: "flex",
                                            gap: 2,
                                            marginLeft: "auto",
                                            flexDirection: { xs: "column", sm: "row" },
                                            width: { xs: "100%", sm: "auto" },
                                        }}
                                    >
                                        <AddFoulWordsSection />
                                        <MDButton
                                            variant="contained"
                                            size="small"
                                            sx={{
                                                color: "black",
                                                paddingY: "13px",
                                                width: { xs: "100%", md: "auto" },
                                            }}
                                        onClick={()=>{ 
                                            dispatch(improveFoulWords())}}
                                        >
                                            Improve With AI
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                                <MDBox pt={3}>
                                    {!showingImproved ? (
                                        <FoulWordsList />
                                    ) : (
                                        <MDBox display="flex" gap={2}>
                                            <MDBox flex={1}>
                                                <FoulWordsList />
                                            </MDBox>
                                            <MDBox flex={1}>
                                                <ImprovedFoulList />
                                            </MDBox>
                                        </MDBox>
                                    )}
                                </MDBox>


                            </MDBox>)
                        }
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default FoulWords